<template>
  <v-row row wrap>
    <v-btn v-if="!exportUrl && $store.getters.hasPermission('ORDER_EXPORT')" :loading="loadingExport" absolute right top color="green white--text" @click="exportOrders">
      EXPORTAR
    </v-btn>
    <v-btn v-else-if="exportUrl" absolute right top color="green--text white" :href="exportUrl" target="_blank">
      Descargar
    </v-btn>

    <v-col cols="12">
      <v-row justify="space-between">
        <v-col cols="12" sm="9" md="10">
          <!-- FILTERS HERE -->
          <v-row align="center">
            <v-col cols="12" sm="6" md="3">
              <order-state-combobox
                  v-model="filters[0].value" @input="fetch" clearable
              ></order-state-combobox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <payment-methods-combobox
                  v-model="filters[1].values" multiple
                  @input="fetch"
              ></payment-methods-combobox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <date-input v-model="filters[2].value"
                          label="Desde"
                          @input="fetch"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <date-input v-model="filters[3].value"
                          label="Hasta"
                          @input="fetch"
              />
            </v-col>
          </v-row>

        </v-col>
        <v-col cols="12" sm="3" md="2">
          <search-input @search="performSearch" v-model="search"/>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">

      <v-data-table
          class="mt-3"
          :headers="headers"
          :items="items"
          :search="search"
          :single-expand="false"
          :server-items-length="totalItems"
          :loading="loading"
          :page.sync="pageNumber"
          :items-per-page.sync="itemsPerPage"
          :sort-by.sync="orderBy"
          :sort-desc.sync="orderDesc"
          :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
          @update:page="fetch"
          @update:sort-by="fetch"
          @update:sort-desc="fetch"
          @update:items-per-page="fetch"
      >

        <template v-slot:item.mode="{item}">
          {{ item.delivery.mode }}
        </template>

        <template v-slot:item.state="{item}">
          {{ $t('delivery.states.' + item.state) }}
        </template>

        <template v-slot:item.name="{item}">
          {{ item.contact.name }}
        </template>

        <template v-slot:item.createdAt="{item}">
          {{ getDateTimeFormat(item.createdAt) }}
        </template>


        <template v-slot:item.totalAmount="{item}">
          ${{ item.totalAmount }}
        </template>

        <template slot="no-data">
          <div class="text-xs-center" v-t="'common.noData'"></div>
        </template>

        <template slot="loading">
          <div class="text-xs-center" v-t="'common.loading'"></div>
        </template>

        <template v-slot:item.action="{ item }">
          <show-button @click="$emit('show', item)"/>
          <edit-button @click="$emit('update', item)"/>

        </template>

        <template v-slot:item.receipt="{ item }">
          <receipt-handler :order="item"></receipt-handler>
        </template>

      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import OrderProvider from "../../../../providers/OrderProvider";

import {ShowButton, SearchInput, EditButton} from "@dracul/common-frontend"
import {DayjsMixin, DateInput} from "@dracul/dayjs-frontend"
import OrderStateCombobox from "@/modules/delivery/combobox/OrderStateCombobox/OrderStateCombobox";
import ReceiptHandler from "@/modules/delivery/components/ReceiptHandler/ReceiptHandler";
import PaymentMethodsCombobox from "@/modules/payment/components/PaymentMethodCombobox/PaymentMethodCombobox";


export default {
  name: "OrderList",
  components: {
    PaymentMethodsCombobox,
    ReceiptHandler, OrderStateCombobox, ShowButton, EditButton, SearchInput, DateInput
  },
  mixins: [DayjsMixin],
  data() {
    return {
      exportUrl: null,
      loadingExport: false,
      items: [],
      totalItems: null,
      loading: false,
      orderBy: null,
      orderDesc: false,
      itemsPerPage: 5,
      pageNumber: 1,
      search: '',
      filters: [
        {
          field: 'state',
          operator: 'eq', //(eq|contain|regex|gt|lt|lte|gte)
          value: ''
        },
        {
          field: 'payment.method',
          operator: 'in', //(eq|contain|regex|gt|lt|lte|gte)
          values: []
        },
        {
          field: 'createdAt',
          operator: 'gte', //(eq|contain|regex|gt|lt|lte|gte)
          value: ''
        },
        {
          field: 'createdAt',
          operator: 'lt', //(eq|contain|regex|gt|lt|lte|gte)
          value: ''
        }
      ]
    }
  },
  computed: {
    headers() {
      return [
        //Entity Headers
        {text: this.$t('delivery.order.labels.number'), value: 'number'},
        {text: this.$t('delivery.order.labels.state'), value: 'state'},
        {text: this.$t('delivery.order.labels.name'), value: 'name'},
        {text: this.$t('delivery.mode.deliveryMode'), value: 'mode'},
        {text: this.$t('delivery.createdAt'), value: 'createdAt'},
        {text: this.$t('delivery.order.labels.totalAmount'), value: 'totalAmount'},
        //Actions
        {text: this.$t('common.actions'), value: 'action', sortable: false},
        {text: 'Factura', value: 'receipt', sortable: false},
      ]
    },
    getOrderBy() {
      return (Array.isArray(this.orderBy)) ? this.orderBy[0] : this.orderBy
    },
    getOrderDesc() {
      return (Array.isArray(this.orderDesc)) ? this.orderDesc[0] : this.orderDesc
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    performSearch() {
      this.pageNumber = 1
      this.fetch()
    },
    exportOrders() {
      this.loadingExport = true
      OrderProvider.orderExport(this.filters).then(r => {
        this.exportUrl = r.data.orderExport

      }).catch(err => {
        console.error(err)
      })
      .finally(() => this.loadingExport = false)
    },
    fetch() {
      this.loading = true
      OrderProvider.paginateOrder(
          this.pageNumber,
          this.itemsPerPage,
          this.search,
          this.filters,
          this.getOrderBy,
          this.getOrderDesc
      ).then(r => {
        this.items = r.data.orderPaginate.items
        this.totalItems = r.data.orderPaginate.totalItems
      }).catch(err => {
        console.error(err)
      }).finally(() => this.loading = false)
    }
  }

}
</script>


